import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-drought-sidebar',
  templateUrl: './drought-sidebar.component.html',
  styleUrls: ['./drought-sidebar.component.scss']
})
export class DroughtSidebarComponent implements OnInit {

  constructor(private utils: UtilsService) { }

  ngOnInit() {
    this.setDefaultParams();
  }

  // Sidebar's only job: put the fixed India/COUNTRY-level params into the shared
  // selectedParams stream so the map and infobox have something to load.
  private setDefaultParams() {
    this.utils.setSelectedParams({
      component: 'DROUGHT',
      actionType: 'filter',
      view: 'Admin',
      pType: 'COUNTRY',
      cType: 'STATE',
      dashboardView: 'INDIA',
      dashboardType: 'gis',
      pUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      locName: 'India',
      locType: 'COUNTRY',
      pEUUID: '00cb31c7-2928-4e6d-adcc-443d478c90d6',
      location: 'India##00cb31c7-2928-4e6d-adcc-443d478c90d6'
    });
  }
}